import { memo } from 'react';
import { IStreamVideo } from '@/shared/types/common';

interface LessonVideoPreviewProps {
  // A ready video: upload and processing are shown by StepVideoUploadStatus and StepVideoServerStatus
  video: IStreamVideo;
}

export const LessonVideoPreview = memo(({ video }: LessonVideoPreviewProps) => {
  if (video.embedUrl) {
    return (
      <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
        <iframe
          src={video.embedUrl}
          className="absolute top-0 left-0 w-full h-full rounded-lg"
          allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
          allowFullScreen
          title="Session video"
        />
      </div>
    );
  }

  if (video.url) {
    return <video controls className="w-full rounded-lg aspect-video bg-black" src={video.url} />;
  }

  return (
    <div className="flex flex-col items-center justify-center p-8 bg-gray-50 rounded-lg">
      <p className="text-red-600 text-center">Video display error</p>
    </div>
  );
});

LessonVideoPreview.displayName = 'LessonVideoPreview';
